import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Table, Button, Modal, FormControl, FormGroup, Alert } from 'react-bootstrap';
import './PlayerPickerModal.css';
import PlayerPickerTable from './PlayerPickerTable.js';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import config from '../config';
import { Link } from 'react-router-dom';

class PlayerPickerModal extends Component {
    constructor(props) {
        super(props);

        this.handleHide = this.handleHide.bind(this);

        this.state = {
            show: false,
            title: '',
            players: [],
            page: 1,
            pageCount: 0,
            limit: 20,
            search: '',
            organisationUUID: '',
            excludeAttribute: '',
            excludeGlobalPage: '',
            excludeUserPlayers: '',
            excludePlayer: '',
            itemsSelected: [],
            singleSelection: false,
            selectedPlayer: null,
            showSerialNumberInput: false,
            serialNumberText: '',
            serialNumberMatches: [],
            serialNumberErrors: [],
            userIsAuthorized: props.userIsAuthorized,
            user: props.user

        };
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        this.setState({ page: selected }, () => {
            this.loadOrganisationPlayersFromServer();
        });
    };

    handleHide() {
        this.props.onHide();
        this.setState({
            itemsSelected: []
        });
    }

    handleChooseClicked() {
        if (this.state.singleSelection) {
            this.props.chosePlayer(this.state.selectedPlayer);
        } else {
            this.props.onChoose(this.state.itemsSelected);
        }

        this.setState({
            itemsSelected: []
        });
    }

    componentDidMount() {}

    loadOrganisationPlayersFromServer() {
        var self = this;

        axios
            .get(
                `${config.baseURL}/organisations/${
                    this.state.organisationUUID
                }/players`,
                {
                    params: {
                        page: self.state.page,
                        limit: self.state.limit,
                        excludePlayer: self.state.excludePlayer,
                        excludeAttribute: self.state.excludeAttribute,
                        excludePage: self.state.excludeGlobalPage,
                        excludeUserPlayers: self.state.excludeUserPlayers,
                        search: self.state.search
                    }
                }
            )
            .then(function(response) {
                self.setState({
                    players: response.data.players,
                    pageCount: response.data.pageCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    componentWillReceiveProps(newProps) {
        console.log('PlayerPickerModal props received:', {
            excludeAttribute: newProps.excludeAttribute,
            excludeGlobalPage: newProps.excludeGlobalPage,
            excludePlayer: newProps.excludePlayer,
            excludeUserPlayers: newProps.excludeUserPlayers
        });
        
        this.setState(
            {
                show: newProps.show,
                title: newProps.title,
                singleSelection: newProps.singleSelection,
                organisationUUID: newProps.organisationUUID,
                excludeAttribute: newProps.excludeAttribute || '',
                excludeGlobalPage: newProps.excludeGlobalPage || '',
                excludePlayer: newProps.excludePlayer || '',
                excludeUserPlayers: newProps.excludeUserPlayers || '',
                userIsAuthorized: newProps.userIsAuthorized || '',
                user: newProps.user || {}
            },
            () => {
                this.loadOrganisationPlayersFromServer();
            }
        );
    }

    selectAll(players) {
        let itemsSelected = this.state.itemsSelected;
        players = players.map(player => player.uuid);
        itemsSelected = [...itemsSelected, ...players];
        let selectedSet = new Set(itemsSelected);
        this.setState({
            itemsSelected: [...selectedSet]
        });
    }

    deselectAll(players) {
        let itemsSelected = this.state.itemsSelected;
        let playerUUIDsToRemove = players.map(player => player.uuid);

        itemsSelected = itemsSelected.filter(function(uuid) {
          return !playerUUIDsToRemove.includes(uuid);
        });

        let selectedSet = new Set(itemsSelected);

        this.setState({
            itemsSelected: [...selectedSet]
        });
    }

    selectionChanged(player, checked) {
        let itemsSelected = this.state.itemsSelected;

        let selectedPlayer = null;
        if (!this.state.singleSelection) {

            if (checked) {
                itemsSelected.push(player.uuid);
            } else {
                itemsSelected = itemsSelected.filter(
                    selectedItem => selectedItem !== player.uuid
                );
            }

        } else {
                 if (checked) {
                    itemsSelected = [];
                    itemsSelected.push(player.uuid);
                    selectedPlayer = player;
                } else {
                    itemsSelected = [];
                }
        }

        var selectedSet = new Set(itemsSelected);

        this.setState({
            itemsSelected: [...selectedSet],
            selectedPlayer
        });
    }

    handleSerialNumberBulkSelect = () => {
        this.setState({ showSerialNumberInput: !this.state.showSerialNumberInput });
    };

    handleSerialNumberTextChange = (event) => {
        this.setState({ serialNumberText: event.target.value });
    };

    processSerialNumbers = () => {
        const { serialNumberText } = this.state;
        
        // Parse serial numbers from text pasted in (newlines, commas, spaces and tabs are dealt with (in theory))
        const serialNumbers = serialNumberText
            .split(/[\n,\s\t]+/)
            .map(sn => sn.trim())
            .filter(sn => sn.length > 0);

        if (serialNumbers.length === 0) {
            this.setState({ 
                serialNumberErrors: ['No serial numbers entered'],
                serialNumberMatches: []
            });
            return;
        }

        // Find matches across all pages (need to call API)
        this.findSerialNumberMatches(serialNumbers);
    };

    findSerialNumberMatches = (serialNumbers) => {
        const { organisationUUID } = this.state;
        
        // Call API to find all matching players by serial numbers
        axios.post(`${config.baseURL}/organisations/${organisationUUID}/players/find-by-serial`, {
            serialNumbers: serialNumbers,
            excludePlayer: this.state.excludePlayer,
            excludeAttribute: this.state.excludeAttribute,
            excludePage: this.state.excludeGlobalPage,
            excludeUserPlayers: this.state.excludeUserPlayers
        })
        .then(response => {
            const { matches, notFound } = response.data;
            
            // Add matched players to selection, avoiding duplicates
            const matchedUUIDs = matches.map(p => p.uuid);
            const currentSelectedItems = this.state.itemsSelected;
            const newUUIDs = matchedUUIDs.filter(uuid => !currentSelectedItems.includes(uuid));
            const newSelectedItems = [...currentSelectedItems, ...newUUIDs];

            // Create appropriate messages
            const messages = [];
            const errors = [];
            
            if (matches.length > 0) {
                const newPlayerCount = newUUIDs.length;
                const duplicateCount = matches.length - newPlayerCount;
                
                if (newPlayerCount > 0) {
                    messages.push(`Found and selected ${newPlayerCount} new players.`);
                }
                
                if (duplicateCount > 0) {
                    messages.push(`${duplicateCount} players were already selected.`);
                }
            }
            
            if (notFound.length > 0) {
                errors.push(`${notFound.length} serial numbers (BUN) could not be found: ${notFound.join(', ')}`);
            }

            this.setState({
                itemsSelected: newSelectedItems,
                serialNumberMatches: matches,
                serialNumberErrors: errors,
                serialNumberMessages: messages,
                serialNumberText: ''
            });
        })
        .catch(error => {
            console.error('Error finding serial numbers:', error);
            this.setState({
                serialNumberErrors: ['Error searching for serial numbers. Please try again.'],
                serialNumberMatches: []
            });
        });
    };

    handleCloseSerialNumberInput = () => {
        this.setState({ 
            showSerialNumberInput: false, 
            serialNumberText: '',
            serialNumberErrors: [],
            serialNumberMatches: []
        });
    };

    render() {
        const { t } = this.props;
        const { showSerialNumberInput, serialNumberText, serialNumberMatches, serialNumberErrors } = this.state;

        const superAdmin = this.state.userIsAuthorized(this.state.user, ['staff_super_admin']);

        return (
            <div className="PlayerPickerModal">
                <Modal
                    show={this.state.show}
                    onHide={this.handleHide}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    dialogClassName="PlayerPickerModal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title">
                            {this.state.singleSelection == false ? (t('PlayerPickerModal.title')) : (t('PlayerPickerModal.title_single'))}
                            {' '}
                            <div className="btn-toolbar pull-right" style={{ "margin-right": "10px"}}>
                                {this.state.singleSelection == false && superAdmin ? (
                                    <Button
                                        className="btn-info btn-sm"
                                        disabled={false}
                                        onClick={this.handleSerialNumberBulkSelect}
                                    >
                                        <em className="fa fa-list" />{' '}
                                        {showSerialNumberInput ? 'Cancel' : t('PlayerPickerModal.bulk_select_serial')}
                                    </Button>
                                ) : null}

                                {this.state.singleSelection == false ? (
                                    <Button
                                        className="btn-primary btn-sm"
                                        disabled={false}
                                        onClick={() => this.selectAll(this.state.players)}
                                    >
                                        <em className="far fa-check-square" />{' '}
                                        {t('PlayerPickerModal.select_all')}
                                    </Button>
                                ) : null}
                                
                                {this.state.singleSelection == false ? (
                                    <Button
                                        className="btn-normal btn-sm"
                                        disabled={false}
                                        onClick={() => this.deselectAll(this.state.players)}
                                    >
                                        <em className="far fa-square" />{' '}
                                        {t('PlayerPickerModal.deselect_all')}
                                    </Button>
                                ) : null}
                            </div>
                        </Modal.Title>
                    </Modal.Header>

                    {showSerialNumberInput && (
                        <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                            <h5>Bulk Select by Serial Numbers (BUN)</h5>
                            <FormGroup>
                                <FormControl
                                    componentClass="textarea"
                                    rows={4}
                                    placeholder="Enter serial numbers separated by new lines, commas, or spaces..."
                                    value={serialNumberText}
                                    onChange={this.handleSerialNumberTextChange}
                                />
                            </FormGroup>
                            <div className="btn-toolbar">
                                <Button
                                    className="btn-success btn-sm"
                                    onClick={this.processSerialNumbers}
                                    disabled={!serialNumberText.trim()}
                                >
                                    <em className="fa fa-search" /> Find & Select Players
                                </Button>
                                <Button
                                    className="btn-default btn-sm"
                                    onClick={this.handleCloseSerialNumberInput}
                                >
                                    Close
                                </Button>
                            </div>

                            {serialNumberMatches.length > 0 && (
                                <Alert bsStyle="success" style={{ marginTop: '10px' }}>
                                    <strong>Success!</strong> Found and selected {serialNumberMatches.length} players.
                                    {serialNumberMatches.length <= 10 ? (
                                        <>
                                            <br />
                                            <small>Serial numbers (BUN): {serialNumberMatches.map(p => p.serialNumber).join(', ')}</small>
                                        </>
                                    ) : (
                                        <>
                                            <br />
                                            <small>
                                                First 5: {serialNumberMatches.slice(0, 5).map(p => p.serialNumber).join(', ')}
                                                {serialNumberMatches.length > 5 && ` ... and ${serialNumberMatches.length - 5} more`}
                                            </small>
                                        </>
                                    )}
                                </Alert>
                            )}

                            {serialNumberErrors.length > 0 && (
                                <Alert bsStyle="warning" style={{ marginTop: '10px' }}>
                                    <strong>Warning:</strong> {serialNumberErrors.length > 0 && serialNumberErrors[0].includes('not found') ? (
                                        // Extract the not found serial numbers from the error message
                                        (() => {
                                            const errorMsg = serialNumberErrors[0];
                                            const match = errorMsg.match(/(\d+) serial numbers not found: (.+)/);
                                            if (match) {
                                                const count = parseInt(match[1]);
                                                const notFoundList = match[2].split(', ');
                                                
                                                return (
                                                    <div>
                                                        <div>{count} serial numbers (BUN) not found.</div>
                                                        {count <= 10 ? (
                                                            <small>Missing: {notFoundList.join(', ')}</small>
                                                        ) : (
                                                            <small>
                                                                First 5 missing: {notFoundList.slice(0, 5).join(', ')}
                                                                {count > 5 && ` ... and ${count - 5} more`}
                                                            </small>
                                                        )}
                                                    </div>
                                                );
                                            }
                                            return errorMsg;
                                        })()
                                    ) : (
                                        <ul style={{ marginBottom: 0, marginTop: '5px' }}>
                                            {serialNumberErrors.map((error, index) => (
                                                <li key={index}>{error}</li>
                                            ))}
                                        </ul>
                                    )}
                                </Alert>
                            )}
                        </div>
                    )}

                    <Modal.Body style={{ margin: '0px', padding: '0px' }}>
                        <PlayerPickerTable
                            singleSelection={this.state.singleSelection}
                            itemsSelected={this.state.itemsSelected}
                            players={this.state.players}
                            onDelete={() => {}}
                            onSelectionChanged={this.selectionChanged.bind(this)}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="text-center">
                            <ReactPaginate
                                previousLabel={t('Pagination.previous')}
                                nextLabel={t('Pagination.next')}
                                breakLabel={<Link to="#">...</Link>}
                                breakClassName={'break-me'}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={10}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                            />
                        </div>
                        <div className="btn-toolbar pull-right">
                            <Button onClick={this.handleHide}>
                                {t('PlayerPickerModal.close')}
                            </Button>
                            <Button
                                disabled={this.state.itemsSelected.length === 0}
                                className="btn-primary"
                                onClick={this.handleChooseClicked.bind(this)}
                            >
                                {this.state.singleSelection == false ? (
                                t('PlayerPickerModal.add_selected')
                                ) : (t('PlayerPickerModal.choose_selected')) }
                                {this.state.singleSelection == false ? (
                                ` (${this.state.itemsSelected.length})`
                                ) : null }
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default translate('translations')(PlayerPickerModal);
